export enum EntityActionLabels {
  UNASSIGNED = 'Unassigned',
  ASSIGNED = 'Assigned'
}
